import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissoesService } from 'src/services/permissoes.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(
    private router: Router,
    private permissaoService: PermissoesService,
  ) { }

  private canAccessRoute(route: ActivatedRouteSnapshot): boolean {
    const requiredPermission = route.data?.['permission'];
    if (!requiredPermission) {
      return true;
    }

    if (this.permissaoService.can(requiredPermission)) {
      return true;
    }

    this.router.navigate(['/notfound']);
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let token = localStorage.getItem('token');

    if (token) {
      return this.canAccessRoute(route);
    }

    localStorage.clear();
    this.router.navigate(['/login']);
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }
}
